import script from "./auth-modal.vue?vue&type=script&setup=true&lang=js"
export * from "./auth-modal.vue?vue&type=script&setup=true&lang=js"

import "./auth-modal.vue?vue&type=style&index=0&id=a3ca1062&lang=css"

const __exports__ = script;

export default __exports__